
<div class="card card-login">
    <div class="card-content">
      <div class="row" *ngIf="!removeLogo">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3>2-Step verification</h3>
          </div>
        </div>
      </div>

      <app-authentication *ngIf="viewToDisplay=='appAuthentication'" [userConfig] = "userConfig" [isChangingDeviceSetup]="changeDevice" (qrCodeScanned)="qrCodeScanned()"></app-authentication>
      <sms-authentication *ngIf="viewToDisplay=='smsAuthentication'" (continue)="sendCodeViaSms($event)" (back)="onBack()"></sms-authentication>
      <verify-code *ngIf="viewToDisplay=='authenticate'" [setup]="true" [userConfig] = "userConfig" [smsEnabled]="smsEnabled" (logoHidden)="removeLogoFromView($event)" [setupMethodChoosen]="twoFAMethod" (goToSetup)="goToSetup()" (deviceConfirmSuccess)="showDeviceConfirmPage()" ></verify-code>
      <choose-auth-method *ngIf="viewToDisplay=='chooseAuthMethod'" (authMethodChosen)="authMethodChosen($event)"></choose-auth-method>
      <app-setup-success *ngIf="viewToDisplay=='deviceConfirmed'" (sendCode)="sendVerificationCode()"></app-setup-success>
    </div>

    <div class="footer text-center" *ngIf="!removeLogo">
      <p class="small">
        <a routerLink="/login" routerLinkActive="active">
          Sign in with a different account</a>
      </p>
    </div>
</div>
